export class MessageTemplate {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly body: string,
  ) {}
}
